module.exports = __webpack_public_path__ + "static/Love_Signs_-_GFX-5a34b2dc17b29ea774ff4a044e3c870e.mp4";